// @flow
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { NegativeMessageContainer } from '@presentational/messages/NegativeMessageContainer';
import { formatCurrency0DP } from '@components/views/grid-utils/renderers';
import { PREVIOUS_CONTRACT_DETAILS_ENUMS } from '@components/renewal-automation/constants';
import { convertUTCDateToHumanReadableDate } from '@src/common-utils/utils';

import { StyledLabel } from '../../common-utils/styledComponents';
import { PaddedAndRaisedSegment } from '../presentational/PaddedAndRaisedSegment';
import { StyledH5 } from '../presentational/headings/StyledH5';
import { If } from '../presentational/If';
import { usePreviousContractDetails } from '../../custom-hooks/usePreviousContractDetails';

const PreviousContractDetailsGrid = ({ tcv, acv, startDate, endDate, arr, rateCard }) => (
  <Grid columns={6} divided={true}>
    <Grid.Row>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.TCV.DISPLAY_NAME} />
        <StyledLabel>{tcv ? formatCurrency0DP.format(tcv) : '-'}</StyledLabel>
      </Grid.Column>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.ACV.DISPLAY_NAME} />
        <StyledLabel>{acv ? formatCurrency0DP.format(acv) : '-'}</StyledLabel>
      </Grid.Column>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.START_DATE.DISPLAY_NAME} />
        <StyledLabel>{convertUTCDateToHumanReadableDate(startDate) || '-'}</StyledLabel>
      </Grid.Column>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.END_DATE.DISPLAY_NAME} />
        <StyledLabel>{convertUTCDateToHumanReadableDate(endDate) || '-'}</StyledLabel>
      </Grid.Column>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.ARR.DISPLAY_NAME} />
        <StyledLabel>{arr ? formatCurrency0DP.format(arr) : '-'}</StyledLabel>
      </Grid.Column>
      <Grid.Column>
        <StyledH5 text={PREVIOUS_CONTRACT_DETAILS_ENUMS.RATE_CARD.DISPLAY_NAME} />
        <StyledLabel>{rateCard || '-'}</StyledLabel>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export const CustomerLastContractDetailsContainer = () => {
  const { previousContractDetails, tcv, acv, startDate, endDate, arr, rateCard } =
    usePreviousContractDetails();

  const errorMessage =
    'Unable to extract previous contract details due to incorrect Account or Org ID. Please enter valid Account and Org ID to fetch proper details for this estimate';

  return (
    <PaddedAndRaisedSegment>
      <If test={!previousContractDetails}>
        <NegativeMessageContainer header={errorMessage} />
      </If>
      <If test={previousContractDetails}>
        <PreviousContractDetailsGrid
          acv={acv}
          arr={arr}
          endDate={endDate}
          rateCard={rateCard}
          startDate={startDate}
          tcv={tcv}
        />
      </If>
    </PaddedAndRaisedSegment>
  );
};
